import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useParams } from 'react-router-dom'
import axios from 'axios';
import Swal from 'sweetalert2';
import Header from './layouts/Header';
import Footer from './layouts/Footer';

export default function SubCategory() {

  const { slug } = useParams()

  const [name, setName] = useState("")

  useEffect(()=>{
     const fetchSubCategory = async () => {
    await axios.get(`https://mysoko.codekali.com/api/subcategory/${slug}`).then(({data})=>{
      const { name } = data.subcategory
      setName(name)
    }).catch(({response:{data}})=>{
      Swal.fire({
        text:data.message,
        icon:"error"
      })
    })
  } 

  const fetchData = () =>{
return fetch(`https://mysoko.codekali.com/api/subcategory/${slug}`)
.then((response) => response.json())
.then((data) => 

// console.log(data) 
  setProducts(data['subcategory']['products'])

   )
 .finally(() => {
  setIsLoading(false);
 });
} 
    fetchSubCategory();
    fetchData();
  },[slug])


// return; 
 
const [products, setProducts] = useState([]);
const [isLoading, setIsLoading] = useState(true);

   function capFirst(str) {

   let dots

   if(str.length > 50){
      dots = '...';
   }else{
      dots = '';

   }

     return (str[0].toUpperCase() + (str.slice(1)).toLowerCase()).slice(0, 50)+dots;
     
 }

  return (
    <>
      <Header/>
    <div className="container-fluid">
         <div className="py-3"></div>
         <h4 className="card-title soko-bold"> {isLoading ? 'Loading...' : ''+name+''} </h4>
                   <div className="py-1"></div>
         <div className="product-container">
            <div className="row">
               { !isLoading ? (products&&products.length>0 && products.map(productsObj => (
               <div key={productsObj.id} className="col-md-3 mb-3">
                  <div className="card soko-round shadow-sm h-100">
                     <div className="card-body">
                        <img loading="lazy" className="img-fluid product-img mb-3 w-100" 
                        src={productsObj.image ? `https://mysoko.codekali.com/product/image/${productsObj.image}` : `https://mysoko.codekali.com/images/avatar.png`} 
                        alt="{productsObj.name}" />
                         <Link to={`/product/${productsObj.slug}`}>
                        <h6 className="soko-bold">{capFirst(productsObj.name)}</h6>
                         </Link>
                        <p className="soko-bold">Price: Ksh. {productsObj.price}</p>
                        <Link className="btn btn-outline-primary w-100 soko-round" to={`/product/${productsObj.slug}`}>
                        <FontAwesomeIcon icon={faEye} /> Shop</Link>

                     </div>

                  </div>
               </div>
               ))) :  Array(50)
               .fill()
               .map((item, index) => (
               <div className="col-md-3 mb-3" key={index}>
                  <div className="card soko-round shadow-sm">
                     <div className="card-body">
                        <div style={{ height: "200px", marginBottom: ".5rem" }}>
                           <Skeleton height={200} width={`100%`} />
                        </div>
                           <h4 className="card-title">
                           <Skeleton height={25} width={`80%`} />
                        </h4>
                        <p className="card-channel mb-0">
                           <Skeleton width={`60%`} />
                        </p>
                    
                        <div className="card-metrics">
                           <Skeleton width={`90%`} />
                        </div>
                     </div>
                  </div>
               </div>
               )) 
               }
            </div>
         </div>
    </div>
      <Footer/>
    </>
  )
}